import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { PageComponent } from '../../../infrastructure/shared/components/page/page';
import { PackagesClient, PackageStatsResponse } from '../../../infrastructure/shared/model/fss.api';
import { firstValueFrom } from 'rxjs';
import { Cube01 } from '../../../infrastructure/shared/icons/cube-01/cube-01';
import { BellRinging03 } from '../../../infrastructure/shared/icons/bell-ringing-03/bell-ringing-03';
import { CreditCard02 } from '../../../infrastructure/shared/icons/credit-card-02/credit-card-02';
import { AdminPackagesTable } from '../admin-packages-table/admin-packages-table';

@Component({
  standalone: true,
  selector: 'app-admin-packages-page',
  imports: [PageComponent, Cube01, BellRinging03, CreditCard02, AdminPackagesTable],
  templateUrl: './admin-packages-page.html',
  styleUrl: './admin-packages-page.scss',
})
export class AdminPackagesPage {
  client = inject(PackagesClient);
  private _cdr = inject(ChangeDetectorRef);

  /** Props */
  stats!: PackageStatsResponse;

  constructor() {
    this.load();
  }

  load() {
    this._getStats().then((res) => {
      this.stats = res.result;
      this._cdr.detectChanges();
    });
  }

  private async _getStats() {
    return await firstValueFrom(this.client.getPackagesStats());
  }
}
